import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import { AppTheme, AppStyles } from '../../../styles/AppTheme';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { Helper } from '../../../common/helpers/Helper';

import { Styles } from './Styles';
import { AppButton } from '../../../common/components/AppButton';
import { Controller } from '../../../common/Controller';

const vsprintf = require('sprintf-js').vsprintf

export class DashboardOrg extends BaseEntityPage {
  constructor(props) {
    super(props);
    this.orgId = this.props.match.params.orgId
    this.pageTitle = 'Welcome'
    this.toFetch = []
    this.noAdd = true
  }

  getHomeContent = (images) => {
    return (
      <div className={css(Styles.contentContainer)}>
        {images && images.map((item, index) => {
          return (
            <div className={css(Styles.imageContainer)}>
              <img src={item.img}
                alt={Helper.getString('explainerImageAlt')}
                className={css(Styles.img)}
                width='400'
                height='400'
              />
            </div>
          )
        })}
      </div>
    )
  }

  renderAboveTable() {
    const images = [
      {
        id: 1,
        img: require('../../../assets/images/home-1.svg')
      },
      {
        id: 2,
        img: require('../../../assets/images/home-2.svg')
      }
    ]
    const buttons = [
      // {
      //   title: 'Manage Audio Ads',
      //   link: '/audio-ads',
      // },
      // {
      //   title: 'Manage Display Campaigns',
      //   link: '/campaigns',
      // },
      // {
      //   title: 'Manage Venues',
      //   link: '/venues',
      // }
    ]
    return (
      <div className={css(AppStyles.container, Styles.mainContainer)}>
        {this.getHomeContent(images)}

        <div className={css(Styles.buttonContainer)}>
          {buttons && buttons.map((item, index) => {
            return (
              <AppButton
                key={'button'}
                onClick={() => { Controller.get().pushRoute(this.baseRoute() + item.link) }}
                buttonText={item.title}
                buttonStyle={Styles.button}
              />
            )
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/admin/dashboard/DashboardOrg.js